export default __webpack_public_path__ + "static/media/forestly-expl-dissect-05b_DE.bb1dcc1b.png";